module.exports = __webpack_public_path__ + "static/media/particles.fad9314e.png";